import { useMemo } from "react";
import { Box, Image } from "@mantine/core";
import type {
  LegacyHistoricalReportAsset,
  LegacyHistoricalReportResolvedAsset,
} from "../../types/legacyHistoricalReport";
import { resolveHistoricalReportAsset } from "../../utils/legacyHistoricalReportAssets";
import { REPORT_IMAGE_ROLE } from "../../utils/reportImageAssets";

interface Props {
  asset: LegacyHistoricalReportAsset;
  assets?: LegacyHistoricalReportResolvedAsset[];
  description: string;
}

export function LegacyHistoricalGraphic({ asset, assets, description }: Props) {
  const source = useMemo(
    () => resolveHistoricalReportAsset(asset, assets),
    [asset, assets]
  );
  return (
    <Box
      component="figure"
      m={0}
      mt="8pt"
      data-historical-asset-id={asset.id}
      data-source-sha256={asset.sha256}
      style={{ breakInside: "avoid", pageBreakInside: "avoid" }}
    >
      <Image
        src={source}
        alt={description}
        data-report-image-role={REPORT_IMAGE_ROLE.clinicalAttachment}
        fit="contain"
        w="100%"
        style={{ aspectRatio: `${asset.width} / ${asset.height}` }}
      />
    </Box>
  );
}
